/*
Created by: Alby Anna Ulahannan
Created on: 04-09-2024
Page Description: This page implements the user profile management feature of the Al Mal Capital web application. 
It displays comprehensive user profile information, including personal details, document information, and relationship manager details.  
*/

import React, { useState, useEffect, useLayoutEffect } from "react";
import Header from "../layout/header";
import HeaderProfile from "../layout/header-profile";
import callingAPI from "../service"
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { setProfileData } from "../redux/reducers/profileSlice"
import { useDispatch } from "react-redux";
import { setDashboardData } from "../redux/reducers/dashboardSlice";

export default function Profile() {
    const dispatch = useDispatch();
    const dashboardDetails = useSelector((state) => state.Dashboard);
    const profileDetailss = useSelector((state) => state.profile);
    const [profileDetails, setProfileDetails] = useState([{
        accounttype: "Fetching...",
        building: "Fetching...",
        citya: "",
        clientid: "",
        clientname: "Fetching...",
        countrya: "Fetching...",
        dob: "Fetching...",
        email: "Fetching...",
        gender: "Fetching...",
        maritalstatus: "Fetching...",
        mobile: "Fetching...",
        nationality: "Fetching...",
        postbox: "",
        rmpid: "Fetching...",
        street: "",
        telnooffice: "Fetching...",
    }])
    const [passportDetails, setPassportDetails] = useState([])
    const [emiratesDetails, setEmiratesDetails] = useState([])
    const [relationshipManagerDetails, setrelationshipManagerDetails] = useState([{
        "rname": "Fetching...",
        "remail": "Fetching...",
        "rmtelnumber": "Fetching..."
    }])
    const refreshToken = dashboardDetails.refreshToken;
    const clientId = dashboardDetails.clientid;

    const navigate = useNavigate();
    const userId = dashboardDetails.userId
    var userLogId = ""

    useEffect(() => {
        console.log("🚀 ~ Profile ~ clientId:", dashboardDetails)
        dispatch(
            setDashboardData({
                moduleId: 2,
            })
        );
        if (!clientId) {
            navigate('/');
            return;
        }
        profileListing();
        handleUserLog()
    }, [])
    useLayoutEffect(() => {

        return () => {
            handleUserLog();
        };
    }, []);
    const handleUserLog = () => {
        const postData = {
            "userId": userId,
            "isApp": "false",
            "moduleId": 2,
            "previousPage": dashboardDetails.previousPage,
            "userSession": refreshToken,
            "userLogId": userLogId
        }
        callingAPI(postData, "user/userLog", 'post')
            .then((response) => {
                const { data } = response;
                if (data.statusCode === 200) {
                    dispatch(
                        setDashboardData({
                            previousPage: 2,
                        })
                    );
                    userLogId = data.data.userLogId
                }
                else {
                    userLogId = ""
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });
    }
    const profileListing = () => {
        if (!clientId) {
            console.error('Client ID not found.');
            return;
        }
        const postData = {
            clientId: clientId,
            "userId": userId,
            //"refreshToken": refreshToken
        };
        callingAPI(postData, "user/profile", 'post')
            .then((response) => {
                const { data } = response;
                if (data.statusCode === 200) {
                    // setProfileDetails(data.data.profile || []);
                    // setPassportDetails(data.data.document.passport || []);
                    // setEmiratesDetails(data.data.document.emirates || []);
                    // setrelationshipManagerDetails(data.data.relationshipManager || []);
                    dispatch(
                        setProfileData({
                            profileDetails: data.data.profile || [],
                            passportDetails: data.data.document.passport || [],
                            emiratesDetails: data.data.document.emirates || [],
                            relationshipManagerDetails: data.data.relationshipManager || []
                        })
                    )

                } else {
                    console.error('Failed to fetch profile details:', data.message);
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });
    };

    return (
        <div className="main-wrapper">
            <div className="top-outer profile-outer">
                <Header />
                <HeaderProfile />
                <hr className="m-0 pb-3" style={{ borderColor: "#83A8BF" }}></hr>
            </div>
            <div className="main-outer">
                <div className="row m-0 main-row">
                    <h3 className="prfile-main-heads" style={{ fontFamily: "Montserrat SemiBold" }}>My Details</h3>
                </div>
                <div className="container-fluid">
                    {profileDetailss && profileDetailss.profileDetails.map((data) => (
                        <div className="row mx-md-1" key={data.clientid}>
                            <div className="col-xl col-lg-3 col-md-4 col-6 py-3">
                                <div className="prfildetl-subhead">Client</div>
                                <div className="prfildetl-subtxt">{data.clientid} {data.clientid ? "-" : ""} {data.clientname}</div>
                            </div>
                            <div className="col-xl col-lg-3 col-md-4 col-6 py-3">
                                <div className="prfildetl-subhead">Date of Birth</div>
                                <div className="prfildetl-subtxt">{data.dob}</div>
                            </div>
                            <div className="col-xl col-lg-3 col-md-4 col-6 py-3">
                                <div className="prfildetl-subhead">Account Type</div>
                                <div className="prfildetl-subtxt">{data.accounttype}</div>
                            </div>
                            <div className="col-xl col-lg-3 col-md-4 col-6 py-3">
                                <div className="prfildetl-subhead">Marital Status</div>
                                <div className="prfildetl-subtxt">{data.maritalstatus}</div>
                            </div>
                            <div className="col-xl col-lg-3 col-md-4 col-6 py-3">
                                <div className="prfildetl-subhead">Nationality</div>
                                <div className="prfildetl-subtxt">{data.nationality}</div>
                            </div>
                            <div className="col-12 d-xl-block d-none">
                            </div>
                            <div className="col-xl col-lg-3 col-md-4 col-6 py-3">
                                <div className="prfildetl-subhead">Telephone</div>
                                <div className="prfildetl-subtxt">{data.telnooffice}</div>
                            </div>
                            <div className="col-xl col-lg-3 col-md-4 col-6 py-3">
                                <div className="prfildetl-subhead">Mobile</div>
                                <div className="prfildetl-subtxt">{data.mobile}</div>
                            </div>
                            <div className="col-xl col-lg-3 col-md-4 col-6 py-3">
                                <div className="prfildetl-subhead">Email</div>
                                <div className="prfildetl-subtxt">{data.email.split(',')[0]} <br /> {data.email.split(',')[1]}</div>
                            </div>
                            <div className="col-xl col-lg-3 col-md-4 col-6 py-3">
                                <div className="prfildetl-subhead">Domicile</div>
                                <div className="prfildetl-subtxt">{data.countrya}</div>
                            </div>
                            <div className="col-xl col-lg-3 col-md-4 col-6 py-3">
                                <div className="prfildetl-subhead">Address</div>
                                <div className="prfildetl-subtxt">{data.building}{data.street ? "," : ""}{data.street}{data.street ? "," : ""}{data.citya}{data.street ? "," : ""}{data.postbox}{data.street ? "," : ""}{data.street ? data.nationality : ""}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="container-fluid padd-top">
                <h3 className="prfile-main-heads color-blue">Relationship Manager</h3>
                {profileDetailss && profileDetailss.relationshipManagerDetails.map((data) => (
                    <div className="prf-detl-wrpr col-xl-8">
                        <div className="prfl-detl-subsection">
                            <div className="prfildetl-subhead color-grey mb-1">Primary RM</div>
                            <div className="prfildetl-subtxt color-subtext">{data.rname ? data.rname : <span className="text-center" style={{ paddingLeft: "30px" }}>-</span>}</div>
                        </div>
                        <div className="prfl-detl-subsection">
                            <div className="prfildetl-subhead color-grey mb-1">Contact No</div>
                            <div className="prfildetl-subtxt color-subtext">{data.rmtelnumber ? data.rmtelnumber : <span className="text-center" style={{ paddingLeft: "30px" }}>-</span>}</div>
                        </div>
                        <div className="prfl-detl-subsection">
                            <div className="prfildetl-subhead color-grey mb-1">Email</div>
                            <div className="prfildetl-subtxt color-subtext">{data.remail ? data.remail : <span className="text-center" style={{ paddingLeft: "30px" }}>-</span>}</div>
                        </div>
                    </div>
                ))}
            </div>
            {profileDetailss.passportDetails.length > 0 &&
                <div className="container-fluid padd-top pb-4 pt-3">
                    <h3 className="prfile-main-heads color-blue">Document Details</h3>
                    <div className="prf-detl-wrpr col-xl-8">
                        <div className="prfl-detl-subsection pb-0">
                            <div className="prfildetl-subhead color-grey">Holder Name</div>
                        </div>
                        <div className="prfl-detl-subsection pb-0">
                            <div className="prfildetl-subhead color-grey">Passport No.</div>
                        </div>
                        {/* <div className="prfl-detl-subsection pb-0">
                            <div className="prfildetl-subhead color-grey">Issue Date</div>
                        </div> */}
                        <div className="prfl-detl-subsection pb-0">
                            <div className="prfildetl-subhead color-grey">Expiry Date</div>
                        </div>
                    </div>
                    {profileDetailss.passportDetails && profileDetailss.passportDetails.map((data, index) => {
                        const isLastChild = index === passportDetails.length - 1;
                        const isSingleChild = passportDetails.length === 1;
                        return (

                            <div className={`prf-detl-wrpr col-xl-8 border-bottom-line ${isLastChild ? 'last-child' : ''} ${isSingleChild ? 'single-child' : ''}`} key={data.idno}>
                                <div className="prfl-detl-subsection pt-0 pb-0">
                                    <div className="prfildetl-subtxt color-subtext">{data.clientdocname ? data.clientdocname : <span className="text-center" style={{ paddingLeft: "30px" }}>-</span>}</div>
                                </div>
                                <div className="prfl-detl-subsection pt-0 pb-0">
                                    <div className="prfildetl-subtxt color-subtext">{data.idno ? data.idno : <span className="text-center" style={{ paddingLeft: "30px" }}>-</span>}</div>
                                </div>
                                {/* <div className="prfl-detl-subsection pt-0 pb-0">
                                    <div className="prfildetl-subtxt color-subtext">{data.issuedate ? data.issuedate : <span className="text-center"style={{paddingLeft:"30px"}}>-</span>}</div>
                                </div> */}
                                <div className="prfl-detl-subsection pt-0 pb-0">
                                    <div className="prfildetl-subtxt color-subtext">{data.expirydate ? data.expirydate : <span className="text-center" style={{ paddingLeft: "30px" }}>-</span>}</div>
                                </div>
                            </div>
                        );
                    })}
                    <div className="prf-detl-wrpr col-xl-8 padd-tp-prfle">
                        <div className="prfl-detl-subsection pb-0">
                            <div className="prfildetl-subhead color-grey">Holder Name</div>
                        </div>
                        <div className="prfl-detl-subsection pb-0">
                            <div className="prfildetl-subhead color-grey">Emirates Id</div>
                        </div>
                        {/* <div className="prfl-detl-subsection pb-0">
                            <div className="prfildetl-subhead color-grey">Issue Date</div>
                        </div> */}
                        <div className="prfl-detl-subsection pb-0">
                            <div className="prfildetl-subhead color-grey">Expiry Date</div>
                        </div>
                    </div>
                    {profileDetailss.emiratesDetails && profileDetailss.emiratesDetails.map((data, index) => {
                        const isLastChild = index === emiratesDetails.length - 1;
                        const isSingleChild = emiratesDetails.length === 1;
                        return (
                            <div className={`prf-detl-wrpr col-xl-8 border-bottom-line ${isLastChild ? 'last-child' : ''} ${isSingleChild ? 'single-child' : ''}`} key={data.idno}>
                                <div className="prfl-detl-subsection pt-0 pb-0">
                                    <div className="prfildetl-subtxt color-subtext">{data.clientdocname ? data.clientdocname : <span className="text-center" style={{ paddingLeft: "30px" }}>-</span>}</div>
                                </div>
                                <div className="prfl-detl-subsection pt-0 pb-0">
                                    <div className="prfildetl-subtxt color-subtext">{data.idno ? data.idno : <span className="text-center" style={{ paddingLeft: "30px" }}>-</span>}</div>
                                </div>
                                {/* <div className="prfl-detl-subsection pt-0 pb-0">
                                    <div className="prfildetl-subtxt color-subtext">{data.issuedate ? data.issuedate : <span className="text-center"style={{paddingLeft:"30px"}}>-</span>}</div>
                                </div> */}
                                <div className="prfl-detl-subsection pt-0 pb-0">
                                    <div className="prfildetl-subtxt color-subtext">{data.expirydate ? data.expirydate : <span className="text-center" style={{ paddingLeft: "30px" }}>-</span>}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>}
        </div>
    )
}